export default {
  global: {
    colors: {brand: '#1a73e8', focus: '#F8F8F8'},
    font: {
      family: 'Arial, Helvetica, sans-serif'
    }
  }
};
